var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIngredientStocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2970_111499)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H7.5V1.23457H6.25V14.1975C6.25 15.5612 5.13071 16.6667 3.75 16.6667C2.36929 16.6667 1.25 15.5612 1.25 14.1975V1.23457H0V0ZM1.875 6.17284H5.625V14.1975C5.625 15.2203 4.78553 16.0494 3.75 16.0494C2.71447 16.0494 1.875 15.2203 1.875 14.1975V6.17284Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 0H16.6667V1.23457H15.4167V10.8624C15.3234 10.8581 15.2295 10.8559 15.1351 10.8559C15.0198 10.8559 14.9053 10.9375 14.7917 10.944V9.16667H11.0417V10.9635C11.0417 10.9635 10.4167 10.8333 10.4167 10.8529V1.23457H9.16667V0Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49034 11.8348L7.53241 13.7469C7.44685 13.918 7.53799 14.1226 7.72028 14.1747L11.4014 15.2257C11.5334 15.2629 11.6748 15.2071 11.7455 15.0899L13.453 12.2626L8.79912 11.6692C8.67077 11.6543 8.54801 11.7194 8.49034 11.8348ZM19.3736 13.7469L18.4157 11.8348C18.358 11.7194 18.2334 11.6525 18.105 11.6692L13.453 12.2626L15.1587 15.0917C15.2294 15.2089 15.3707 15.2647 15.5028 15.2275L19.1839 14.1766C19.368 14.1226 19.4573 13.918 19.3736 13.7469ZM15.4191 15.8339C15.1047 15.8339 14.809 15.6665 14.649 15.3987L13.453 13.4158L12.2588 15.3987C12.097 15.6684 11.8013 15.8358 11.4869 15.8358C11.4032 15.8358 11.3195 15.8246 11.2395 15.8004L8.69123 15.0713V18.3822C8.69123 18.6556 8.87724 18.8937 9.14137 18.9588L13.1628 19.9651C13.3526 20.0116 13.5516 20.0116 13.7395 19.9651L17.7646 18.9588C18.0288 18.8919 18.2148 18.6538 18.2148 18.3822V15.0713L15.6665 15.7986C15.5865 15.8227 15.5028 15.8339 15.4191 15.8339Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2970_111499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngredientStocks);
export default __webpack_public_path__ + "static/media/IngredientStocks.32e56a642d05e2f142a9218a5cd30525.svg";
export { ForwardRef as ReactComponent };